import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Analytics = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M9.33334 20.0001V14.0001H5.00063C4.448 14.0001 4 14.4478 4 15.0001V19.0001C4 19.5523 4.448 20.0001 5.00063 20.0001H9.33334ZM9.33334 20.0001H14.6667M9.33334 20.0001L9.33336 5.00006C9.33336 4.44778 9.78136 4.00006 10.334 4.00006H13.6661C14.2187 4.00006 14.6667 4.44778 14.6667 5.00006V20.0001M14.6667 20.0001L14.6667 9.00006H18.9994C19.552 9.00006 20 9.44778 20 10.0001V19.0001C20 19.5523 19.552 20.0001 18.9994 20.0001H14.6667Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='square'
        strokeLinejoin='round'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15.417 5V8.25H18.999C19.966 8.25 20.75 9.0335 20.75 10V19C20.75 19.9665 19.966 20.75 18.999 20.75H5.001C4.03395 20.75 3.25 19.9665 3.25 19V15C3.25 14.0335 4.03395 13.25 5.001 13.25H8.58306L8.58307 5C8.58307 4.0335 9.36702 3.25 10.3341 3.25H13.666C14.633 3.25 15.417 4.0335 15.417 5ZM10.0839 5C10.0839 4.86193 10.1959 4.75 10.3341 4.75H13.666C13.8041 4.75 13.9161 4.86193 13.9161 5V8.99188L13.9161 9L13.9161 19.25H10.0839L10.0839 5ZM5.001 14.75H8.58306L8.58306 19.25H5.001C4.86285 19.25 4.75086 19.1381 4.75086 19V15C4.75086 14.8619 4.86285 14.75 5.001 14.75Z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
